module.exports = __webpack_public_path__ + "img/bg_mobile.422d5c9e.jpg";